{
  "ancillaries": {
    "bundle": {
      "seatMapToggle": {
        "includedSeat": "Tämä kombo sisältää: {seatType} {seatNumber}.",
        "incompatibleSeat": "Tämä kombo ei ole saatavilla maksuttomalle istuinpaikallesi {seatNumber}. Lisää kombo valitsemalla toinen istuinpaikkatyyppi.",
        "showSeatMap": "Näytä istuinkartta"
      }
    }
  },
  "purchase": {
    "success": {
      "alternateCtaButton": "Tarkastele varaustietojasi ja lisää lisäpalveluita"
    }
  }
}
